export default __webpack_public_path__ + "static/media/statistics.3295dd5e.svg";